module.exports = __webpack_public_path__ + "img/partnership_banner.154dc0c1.jpg";